<template>
  <SkeletonLoader>
    <div class="ba-skeleton">
      <!-- Header -->
      <div class="sk-line sk-line--title" style="width: 30%; margin-bottom: 20px;"></div>

      <!-- Two-column layout: filter panel + stats panel -->
      <div class="ba-skeleton__panels">
        <!-- Left: Filter Panel (xl=4) -->
        <div class="ba-skeleton__panel ba-skeleton__panel--filter">
          <div class="sk-line sk-line--title" style="width: 55%;"></div>

          <!-- From date picker -->
          <div class="ba-skeleton__filter-item">
            <div class="sk-line sk-line--sm" style="width: 30%; margin-bottom: 6px;"></div>
            <div class="sk-rect" style="height: 34px; width: 100%; border-radius: 4px;"></div>
          </div>

          <!-- To date picker -->
          <div class="ba-skeleton__filter-item">
            <div class="sk-line sk-line--sm" style="width: 25%; margin-bottom: 6px;"></div>
            <div class="sk-rect" style="height: 34px; width: 100%; border-radius: 4px;"></div>
          </div>

          <!-- Checkbox -->
          <div class="ba-skeleton__filter-item">
            <div style="display: flex; align-items: center; gap: 8px;">
              <div class="sk-rect" style="height: 16px; width: 16px; border-radius: 3px;"></div>
              <div class="sk-line sk-line--sm" style="width: 55%; margin-bottom: 0;"></div>
            </div>
          </div>

          <!-- Apply button -->
          <div class="sk-rect" style="height: 38px; width: 130px; border-radius: 6px; margin-top: 8px;"></div>
        </div>

        <!-- Right: Stats Panel (xl=8) -->
        <div class="ba-skeleton__panel ba-skeleton__panel--stats">
          <div class="sk-line sk-line--title" style="width: 50%;"></div>

          <!-- 4 metric cards -->
          <div class="ba-skeleton__metrics-grid">
            <div v-for="card in metricCards" :key="card.id" class="ba-skeleton__metric-card">
              <div class="sk-circle sk-circle--md" style="flex-shrink: 0;"></div>
              <div style="flex: 1; min-width: 0;">
                <div class="sk-line sk-line--sm" :style="{ width: card.labelWidth, marginBottom: '6px' }"></div>
                <div class="sk-line sk-line--lg" :style="{ width: card.valueWidth, marginBottom: '6px' }"></div>
                <div class="sk-line sk-line--sm" :style="{ width: card.detailWidth }"></div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Table -->
      <div class="ba-skeleton__table">
        <div class="ba-skeleton__table-header">
          <div v-for="h in headers" :key="h.id" class="sk-rect" :class="{ 'ba-skeleton__hide-mobile': h.hideMobile }" :style="{ height: '14px', width: h.width }"></div>
        </div>
        <div v-for="r in 8" :key="'row-' + r" class="ba-skeleton__table-row">
          <div class="sk-line" :style="{ width: col1[r] }"></div>
          <div class="sk-line" :style="{ width: col2[r] }"></div>
          <div class="sk-line sk-line--sm" :style="{ width: col3[r] }"></div>
          <div class="sk-line ba-skeleton__hide-mobile" :style="{ width: col4[r] }"></div>
          <div class="sk-rect ba-skeleton__hide-mobile" style="height: 22px; width: 60px; border-radius: 12px;"></div>
          <div class="sk-line sk-line--sm ba-skeleton__hide-mobile" :style="{ width: col5[r] }"></div>
        </div>
      </div>
    </div>
  </SkeletonLoader>
</template>

<script>
import SkeletonLoader from '@/components/SkeletonLoader.vue';

export default {
  name: 'BrokenAppointmentsSkeleton',
  components: { SkeletonLoader },
  data() {
    return {
      metricCards: [
        { id: 'this-week', labelWidth: '50%', valueWidth: '35%', detailWidth: '70%' },
        { id: 'last-week', labelWidth: '45%', valueWidth: '30%', detailWidth: '65%' },
        { id: 'this-month', labelWidth: '55%', valueWidth: '40%', detailWidth: '75%' },
        { id: 'last-month', labelWidth: '48%', valueWidth: '32%', detailWidth: '60%' },
      ],
      headers: [
        { id: 'h-patient', width: '16%', hideMobile: false },
        { id: 'h-date', width: '12%', hideMobile: false },
        { id: 'h-code', width: '14%', hideMobile: false },
        { id: 'h-fee', width: '10%', hideMobile: true },
        { id: 'h-status', width: '12%', hideMobile: true },
        { id: 'h-followup', width: '14%', hideMobile: true },
      ],
      col1: { 1: '14%', 2: '11%', 3: '16%', 4: '12%', 5: '13%', 6: '10%', 7: '15%', 8: '11%' },
      col2: { 1: '10%', 2: '12%', 3: '9%', 4: '11%', 5: '10%', 6: '13%', 7: '11%', 8: '9%' },
      col3: { 1: '12%', 2: '10%', 3: '14%', 4: '11%', 5: '13%', 6: '9%', 7: '12%', 8: '10%' },
      col4: { 1: '8%', 2: '7%', 3: '9%', 4: '6%', 5: '8%', 6: '7%', 7: '9%', 8: '8%' },
      col5: { 1: '11%', 2: '9%', 3: '12%', 4: '10%', 5: '8%', 6: '11%', 7: '10%', 8: '9%' },
    };
  }
}
</script>

<style lang="scss" scoped>
.ba-skeleton__panels {
  display: flex;
  gap: 16px;
  margin-bottom: 24px;
}

.ba-skeleton__panel {
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 16px;

  &--filter {
    flex: 4;
  }

  &--stats {
    flex: 8;
  }
}

.ba-skeleton__filter-item {
  margin-bottom: 12px;
}

.ba-skeleton__metrics-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
}

.ba-skeleton__metric-card {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 14px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
}

.ba-skeleton__table {
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  overflow: hidden;
}

.ba-skeleton__table-header {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 14px 16px;
  background: #f8fafc;
  border-bottom: 1px solid #e2e8f0;
}

.ba-skeleton__table-row {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 12px 16px;
  border-bottom: 1px solid #f1f5f9;
}

/* Tablet: stats cards 2x2, panels still side by side */
@media (max-width: 1199px) {
  .ba-skeleton__panels {
    flex-direction: column;
  }
}

/* Mobile: stack everything, hide extra columns */
@media (max-width: 768px) {
  .ba-skeleton__metrics-grid {
    grid-template-columns: 1fr;
  }

  .ba-skeleton__hide-mobile {
    display: none;
  }
}
</style>
